import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import { useTheme } from "@mui/material/styles";
import { Check, ChevronRight, Eye, MessageSquare } from "lucide-react";
import {
  CAMPAIGN_AGENT_STEP_APPLY,
  CAMPAIGN_AGENT_STEP_ASK,
  CAMPAIGN_AGENT_STEP_REVIEW,
} from "../../i18n/keysTranslations";
import { useTranslationApp } from "../../lib/i18next";
import { INPUT_COLOR_BORDER } from "../../utils/colors";

const CAMPAIGN_AGENT_WELCOME_STEPS = [
  { id: "ask", icon: MessageSquare, labelKey: CAMPAIGN_AGENT_STEP_ASK },
  { id: "review", icon: Eye, labelKey: CAMPAIGN_AGENT_STEP_REVIEW },
  { id: "apply", icon: Check, labelKey: CAMPAIGN_AGENT_STEP_APPLY },
];

const CampaignAgentWelcomeSteps = () => {
  const { t } = useTranslationApp();
  const theme = useTheme();

  return (
    <Box
      sx={{
        display: "flex",
        flexWrap: "wrap",
        alignItems: "flex-start",
        justifyContent: "center",
        columnGap: 0.75,
        rowGap: 1,
        my: 2,
        width: "100%",
      }}
    >
      {CAMPAIGN_AGENT_WELCOME_STEPS.map((step, index) => {
        const Icon = step.icon;
        return (
          <Box
            key={step.id}
            sx={{
              display: "flex",
              alignItems: "flex-start",
              gap: 0.75,
            }}
          >
            {index > 0 ? (
              <Box
                sx={{
                  display: "flex",
                  alignItems: "center",
                  height: 28,
                  color: "text.disabled",
                }}
              >
                <ChevronRight size={14} color={theme.palette.text.disabled} />
              </Box>
            ) : null}
            <Box
              sx={{
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                gap: 0.5,
                minWidth: 52,
              }}
            >
              <Box
                sx={{
                  width: 28,
                  height: 28,
                  borderRadius: "50%",
                  border: `1px solid ${INPUT_COLOR_BORDER}`,
                  bgcolor: "fields.background",
                  display: "grid",
                  placeItems: "center",
                  color: "text.primary",
                }}
              >
                <Icon size={14} color={theme.palette.text.primary} />
              </Box>
              <Typography
                variant="caption"
                sx={{ fontWeight: 600, color: "text.primary", lineHeight: 1.2 }}
              >
                {t(step.labelKey)}
              </Typography>
            </Box>
          </Box>
        );
      })}
    </Box>
  );
};

export default CampaignAgentWelcomeSteps;
